<template>
  <div :class="{'loading-attendance': balancesPanelLoading}">
    <table class="table table-striped holidays-table">
      <thead>
      <tr>
        <th colspan="2">
          {{ trans.attendance.statistics.balances }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="typeof balances.holiday !== 'undefined'">
        <th>
          {{ trans.workDayTypes.holiday }}
        </th>
        <td v-if="country == 'sk'">
          {{ Number(balances.holiday) }} d.
          ({{ balances.holiday * attendance.daily_working_fund_in_hours }} h.)
        </td>
        <td v-else>
          {{ Number(balances.holiday) }} h.
        </td>
      </tr>
      <tr v-else>
        <td class="text-center text-muted py-3">
          {{ trans.attendance.statistics.nobalances }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'balances',
  data: function () {
    return {
      balancesPanelLoading: false
    }
  },

  props: {
    'attendance': {
      type: Object
    },
    'employeeContractId': {
      type: Number
    },
    'selectedMonth': {
      type: String
    },
    'month': {
      type: Number
    },
    'balances': {
      type: Object
    },
    'trans': {
      type: Object
    },
    'country': {
      type: String
    },
  },


  methods: {
    refreshAttendance(withLoading = true) {
      this.$parent.$emit('refreshattendance', withLoading);
    },
  },

  computed: {}
}
</script>


<style lang="scss" scoped>
.btn-square-loading-save,
.btn.loading.btn-square-loading-save {
  width: 38px;
  height: 35px;
  padding-right: 0.75rem !important;
  text-align: center;

  .loadingSpinner {
    margin-left: -10px;
    left: auto;
    right: auto;
  }
}

.form-control {
  padding-right: 12px !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/show/Balances.vue